export enum AxnAdminUserAccountStateTypes {
    ARCHIVE = 'archive',
    RESTORE = 'restore',
    DELETE = 'perm-archive'
}